import NewsView from "@/views/news/NewsView";
import NewsOverview from "@/views/news/NewsOverview";
import BreakingNews from "@/views/news/BreakingNews";
import OldNews from "@/views/news/OldNews";
import Events from "@/views/news/Events";
import Jobs from "@/views/news/Jobs";
import ViewJob from "@/views/news/ViewJob";

export const newsRoutes = {
  path: '/news',
  name: 'NewsView',
  component: NewsView,
  children: [
    {
      path: 'overview',
      name: 'NewsOverview',
      component: NewsOverview,
    },
    {
      path: 'breaking-news',
      name: 'BreakingNews',
      component: BreakingNews,
      meta: { title: "Breaking News - TAIR" },
    },
    {
      path: 'old-news',
      name: 'OldNews',
      component: OldNews,
      meta: { title: "What was News - TAIR" },
    },
    {
      path: 'events',
      name: 'Events',
      component: Events,
      meta: { title: "Conferences and Events - TAIR" },
    },
    {
      path: 'jobs',
      name: 'Jobs',
      component: Jobs,
    },
    {
      path: 'jobs/view',
      name: 'ViewJob',
      component: ViewJob,
    },
  ]
}